// Cart Notes
document.addEventListener("DOMContentLoaded", function(event) {
  const cart_note_trigger = document.querySelector('.cart-ordernote-heading');

  if(cart_note_trigger) {
    cart_note_trigger.addEventListener('click', event => {

      const cart_note = document.querySelector('.cart__note .field__input');

      if (cart_note.style.display === "none") {
        cart_note.style.display = "block";
      } else {
        cart_note.style.display = "none";
      }

    });
  }

});

// Cart GWP Slider
/*
var flkty = new Flickity( '.cart-gwp-slider', {
  contain: true,
  prevNextButtons: false
});
*/

// Change the slider to the relevant product based on their tier
/*
let gwp_progress = document.getElementById('gwp-progress');
let slide_no = gwp_progress.getAttribute('data-tierlevel');
flkty.select(slide_no);
*/
